import { doesValueExist, safeParse, safeStringify } from 'utils';

export const SESSION_STORAGE_KEYS = {
  DOWNLOAD_UNIQUE_ID: 'downloadUniqueId',
  CONFIRMED_PASSCODE_SECURE_LINK_ID: 'confirmedPasscodeSecureLinkId',
  // Prefix only - the listing id is appended, so each listing keeps its own entry.
  // See getDismissedBannersStorageKey in the AiDraftBanner component.
  DISMISSED_AI_DRAFT_BANNERS: 'dismissedAiDraftBanners',
  // Prefix only, listing id appended. Keeps "AI Drafted Field Edited" to one event
  // per field per session - see the AiDraftedFieldsTracker component.
  REPORTED_AI_DRAFTED_FIELD_EDITS: 'reportedAiDraftedFieldEdits',
};

export default {
  ram: {} as Record<string, string>,
  setItem(key: string, value: Record<string, any> | string | boolean) {
    try {
      sessionStorage.setItem(key, safeStringify(value));
    } catch (e) {
      this.ram[key] = safeStringify(value);
    }
  },
  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      this.ram[key] = undefined;
    }
  },
  getItem<T>(key: string): T {
    const sessionStorageItem = safeParse(sessionStorage.getItem(key));

    if (doesValueExist(sessionStorageItem)) return sessionStorageItem;

    return safeParse(this.ram[key]);
  },
};
